<template>
  <v-container>
    <v-toolbar>
          <v-toolbar-title>Your Information</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text v-on:click="gotoNext()">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <br>
    <v-card>
      <v-card-text>
        <v-text-field
              v-model="signupGivenName"
              label="Given Name"
              :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
              v-model="signupLastName"
              label="Last Name"
              :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
              v-model="signupCompanyName"
              label="Company Name"
              :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
              v-model="signupAddress1"
              label="Address 1"
              :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
              v-model="signupAddress2"
              label="Address 2"
              :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
              v-model="signupCity"
              label="City"
              :rules="[rules.required]"
        ></v-text-field>
         <v-select 
          v-model="signupCountry"
          :items=countries
          :rules="[rules.required]"
          label="Country"
        ></v-select>
        <v-select 
          v-if="signupCountry == 'Canada'"
          v-model="signupProvince"
          :items=provinces
          :rules="[rules.required]"
          label="Province"
        ></v-select>
        <v-select 
          v-if="signupCountry == 'United States'"
          v-model="signupProvince"
          :items=states
          :rules="[rules.required]"
          label="State"
        ></v-select>
        
        <v-text-field
              v-if="signupCountry == 'Canada'"
              v-model="signupPostal"
              label="Postal Code"
              :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
              v-if="signupCountry == 'United States'"
              v-model="signupPostal"
              label="ZIP"
              :rules="[rules.required]"
        ></v-text-field>
        <v-btn color="success" v-on:click="gotoNext">Next</v-btn>
      </v-card-text>
    </v-card>
  </v-container>
  
</template>

<script>

  import {mask} from 'vue-the-mask';
  import SignupMixin from '../mixins/SignupMixin'

  import gql from 'graphql-tag'; 
  
  const checkEmailQry = gql`
    query checkEmail($email: String) {
      checkEmail(email: $email) {
        user_id
        email
      }
    }
  `;

  export default {
    name: 'SignupEmailAndPassword',
    directives: {
      mask
    },
    mixins: [SignupMixin],
    computed: {
      
    },
    data: () => ({
     countries: ['Canada', 'United States'],
     provinces: [
       {text: 'British Columbia', value: 'BC'},
       {text: 'Alberta', value: 'AB'},
       {text: 'Saskatchewan', value: 'SK'},
       {text: 'Manitoba', value: 'MB'},
       {text: 'Ontario', value: 'ON'},
       {text: 'Quebec', value: 'QB'},
       {text: 'New Brunswick', value: 'NB'},
       {text: 'Nova Scotia', value: 'NS'},
       {text: 'Newfoundland', value: 'NL'},       
     ],
     states: [
        {
            text:  "Alabama",
            value: "AL"
        },
        {
            text:  "Alaska",
            value: "AK"
        },
        {
            text:  "American Samoa",
            value: "AS"
        },
        {
            text:  "Arizona",
            value: "AZ"
        },
        {
            text:  "Arkansas",
            value: "AR"
        },
        {
            text:  "California",
            value: "CA"
        },
        {
            text:  "Colorado",
            value: "CO"
        },
        {
            text:  "Connecticut",
            value: "CT"
        },
        {
            text:  "Delaware",
            value: "DE"
        },
        {
            text:  "District Of Columbia",
            value: "DC"
        },
        {
            text:  "Federated States Of Micronesia",
            value: "FM"
        },
        {
            text:  "Florida",
            value: "FL"
        },
        {
            text:  "Georgia",
            value: "GA"
        },
        {
            text:  "Guam",
            value: "GU"
        },
        {
            text:  "Hawaii",
            value: "HI"
        },
        {
            text:  "Idaho",
            value: "ID"
        },
        {
            text:  "Illinois",
            value: "IL"
        },
        {
            text:  "Indiana",
            value: "IN"
        },
        {
            text:  "Iowa",
            value: "IA"
        },
        {
            text:  "Kansas",
            value: "KS"
        },
        {
            text:  "Kentucky",
            value: "KY"
        },
        {
            text:  "Louisiana",
            value: "LA"
        },
        {
            text:  "Maine",
            value: "ME"
        },
        {
            text:  "Marshall Islands",
            value: "MH"
        },
        {
            text:  "Maryland",
            value: "MD"
        },
        {
            text:  "Massachusetts",
            value: "MA"
        },
        {
            text:  "Michigan",
            value: "MI"
        },
        {
            text:  "Minnesota",
            value: "MN"
        },
        {
            text:  "Mississippi",
            value: "MS"
        },
        {
            text:  "Missouri",
            value: "MO"
        },
        {
            text:  "Montana",
            value: "MT"
        },
        {
            text:  "Nebraska",
            value: "NE"
        },
        {
            text:  "Nevada",
            value: "NV"
        },
        {
            text:  "New Hampshire",
            value: "NH"
        },
        {
            text:  "New Jersey",
            value: "NJ"
        },
        {
            text:  "New Mexico",
            value: "NM"
        },
        {
            text:  "New York",
            value: "NY"
        },
        {
            text:  "North Carolina",
            value: "NC"
        },
        {
            text:  "North Dakota",
            value: "ND"
        },
        {
            text:  "Northern Mariana Islands",
            value: "MP"
        },
        {
            text:  "Ohio",
            value: "OH"
        },
        {
            text:  "Oklahoma",
            value: "OK"
        },
        {
            text:  "Oregon",
            value: "OR"
        },
        {
            text:  "Palau",
            value: "PW"
        },
        {
            text:  "Pennsylvania",
            value: "PA"
        },
        {
            text:  "Puerto Rico",
            value: "PR"
        },
        {
            text:  "Rhode Island",
            value: "RI"
        },
        {
            text:  "South Carolina",
            value: "SC"
        },
        {
            text:  "South Dakota",
            value: "SD"
        },
        {
            text:  "Tennessee",
            value: "TN"
        },
        {
            text:  "Texas",
            value: "TX"
        },
        {
            text:  "Utah",
            value: "UT"
        },
        {
            text:  "Vermont",
            value: "VT"
        },
        {
            text:  "Virgin Islands",
            value: "VI"
        },
        {
            text:  "Virginia",
            value: "VA"
        },
        {
            text:  "Washington",
            value: "WA"
        },
        {
            text:  "West Virginia",
            value: "WV"
        },
        {
            text:  "Wisconsin",
            value: "WI"
        },
        {
            text:  "Wyoming",
            value: "WY"
        }
    ],
    }),
    methods: {
      checkEmail: function() {
        let self = this;
        return new Promise(function(resolve,reject) {  
            let variables = {
              email:  self.signupEmail,
            };
            self.$global.apolloClient.query({query: checkEmailQry, variables, fetchPolicy: 'network-only'})
            .then( function(result) {
              if (result.data.checkEmail.user_id == -1) {
                // user does not exist
              } else {
                // user exists already
                console.log('user exists already');
                self.emailError = true;
                self.emailHint = 'The user already exists.';
              }
              return resolve(true);
            });
        });     
      },
    },
    beforeMount() {
    },
    watch: {
      
    },
    filters: {

    },
  }
</script>
